import gql from 'graphql-tag'

export const fetchMinCartForCatalogQuery = gql(`
query ($cart_id: String!) {
  cart(
      cart_id: $cart_id
  ) {
    note_for_driver
    customer_order_number
    delivery_date
    delivery_method
    runnertype
    progress_bar_data {
      iPalletQuantity,
      iMinimumOrderWeight,
      iMaximumOrderWeight,
      iTotalCartWeight,      
      iTotalCartPalletQty,
      iTotalQty,      
      iRunnerType,
      iFullTruck,
      iFullTruckFlag,
      iFullTruckRemaining,      
      msg,
      canProceed,
      min_weight_reached,
      iTruckQuantity
    }
    id
    ship_to_id
    grand_total_your_price
    items {
      id
      product {
        id
        name
        sku
        image {
          url
        }
        __typename
      }
      quantity
      quantity_total
    }
  }
}
`)
